import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { MaintenanceUsersList } from './MaintenanceUsersList';

export const MaintenanceUsersListBridge = react2angular(MaintenanceUsersList, [
  'selectedBusinessId',
  'onGridNeedResize'
]);


